module.exports = __webpack_public_path__ + "img/djf.c9f4b29a.png";